import Alert, { alertType } from 'atoms/Alert';
import Divider from 'atoms/Divider';
import Heading from 'atoms/Heading';
import LinkIcon from 'atoms/LinkIcon';
import SignUpWith from 'atoms/SignUpWith';
import TextWithLinkIcon from 'molecules/TextWithLinkIcon';
import { signIn } from 'next-auth/react';
import { useRouter } from 'next/router';
import SidebarWithTimeline from 'organisms/SidebarWithTimeline';
import SignInForm from 'organisms/SignInForm';
import { useState } from 'react';
import { toSafeCallbackUrl } from 'utils/safeCallbackUrl';

const SignUp = () => {
  const router = useRouter();
  // Set by requireAuthentication when it bounced a deep link to /login —
  // sending it back through signIn resumes that page after authenticating.
  const callbackUrl = toSafeCallbackUrl(router.query?.callbackUrl);
  const [showVerification, setShowVerification] = useState(false);
  const [alertState, setAlertState] = useState({
    type: alertType.info,
    showAlert: false,
    alertMessage: 'something went wrong',
  });

  // Google Handler function
  async function handleGoogleSignin() {
    signIn('google', { callbackUrl });
  }

  // Microsoft Handler function
  async function handleMicrosoftSignin() {
    signIn('azure-ad-b2c', { callbackUrl }).catch(() => {
      setAlertState({
        type: alertType.error,
        showAlert: true,
        alertMessage: 'Could not sign in with Microsoft. Please try again.',
      });
    });
  }

  return (
    <div className="min-h-screen flex relative max-md:bg-[#F4F5F6]">
      <SidebarWithTimeline
        width="max-w-[50%]"
        showImage={true}
        type="forLogin"
        className="bg-primary-900"
      />
      <div className="w-full flex flex-col max-md:px-4 max-md:py-5 max-md:pb-8 md:bg-white md:p-10 2xl:p-[60px]">
        <div className="flex justify-end max-md:mb-3">
          <TextWithLinkIcon
            href="https://www.getafto.com/faq"
            icon="arrowRight"
            size="16"
            text1="Lost or have trouble?"
            text2="Get Help"
            classForIcon="fill-primary-900 group-hover:fill-primary-800"
          />
        </div>
        <div className="h-full flex flex-col justify-center relative items-center">
          <div className="max-w-[70%] w-full max-md:max-w-[420px] max-md:bg-white max-md:border max-md:border-secondary-200 max-md:rounded-xl max-md:p-5 max-md:shadow-sm">
            {!showVerification && (
              <div>
                <Heading
                  type="h1"
                  className="text-black-800 font-semibold"
                  children="Welcome to Afto"
                />
                <div className="flex gap-4 mt-4">
                  <SignUpWith
                    text="Continue with Google "
                    className=""
                    handleClick={handleGoogleSignin}
                    imgAlt="Google"
                    imgSrc="/images/Google.svg"
                  />
                  {/* <SignUpWith
                    text="Continue with Microsoft "
                    className=""
                    handleClick={handleMicrosoftSignin}
                    imgAlt="MIcrosoft"
                    imgSrc="/images/Microsoft.svg"
                  /> */}
                </div>
                <Divider className="my-8 2xl:my-[42px] mx-auto" text="OR" />
              </div>
            )}

            <SignInForm
              showVerification={showVerification}
              setShowVerification={setShowVerification}
              setAlertState={setAlertState}
            />
          </div>
          {alertState.showAlert && (
            <Alert
              variant={alertState.type || alertType.info}
              children={alertState.alertMessage || 'Something went wrong'}
              alertClass="w-full max-md:max-w-[420px] max-md:mt-3 md:mb-4 2xl:mb-7 md:absolute md:bottom-0"
            />
          )}
        </div>
        <div
          className={`w-full max-md:max-w-[420px] ${
            showVerification ? 'flex justify-between' : 'self-end max-md:self-center'
          } mt-4 md:mt-0`}
        >
          {showVerification && (
            <LinkIcon
              icon="arrowleft"
              variant="body"
              href=""
              size="16"
              children="Back"
              className="flex-row-reverse"
              classForIcon="fill-primary-900 group-hover:fill-primary-800"
              onClick={(e) => {
                e.preventDefault();
                setShowVerification(false);
                setAlertState({
                  showAlert: false,
                  alertMessage: '',
                });
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SignUp;
